// src/components/ContactForm.jsx
import React, { useState } from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaLinkedinIn } from 'react-icons/fa';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState({
    submitting: false,
    success: null,
    error: null,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, success: null, error: null });

    ////console.log('Submitting Contact Form:', formData); // Log form data

    try {
      const response = await fetch(process.env.REACT_APP_CONTACT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      ////console.log('Received Response:', response); // Log raw response

      if (response.ok) {
        const responseData = await response.json();
        //console.log('Response Data:', responseData); // Log JSON response
        setStatus({ submitting: false, success: 'Your message has been sent!', error: null });
        setFormData({ name: '', email: '', message: '' });
      } else {
        const errorData = await response.json();
        //console.error('Error Response Data:', errorData); // Log error response
        setStatus({ submitting: false, success: null, error: errorData.message || 'Something went wrong.' });
      }
    } catch (error) {
      //console.error('Fetch Error:', error); // Log fetch error
      setStatus({ submitting: false, success: null, error: error.message || 'Something went wrong.' });
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Main Content */}
      <main className="flex-grow">
        {/* Contact Form */}
        <section id="contact-us" className="container mx-auto py-12 px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Contact Us</h2>
          <form className="max-w-lg mx-auto" onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="name" className="block text-gray-700 font-semibold mb-2">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                placeholder="Your Name"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                placeholder="your.email@example.com"
              />
            </div>
            <div className="mb-6">
              <label htmlFor="message" className="block text-gray-700 font-semibold mb-2">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                required
                rows="5"
                value={formData.message}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
                placeholder="Your message..."
              ></textarea>
            </div>
            {status.error && <p className="text-red-500 mb-4">{status.error}</p>}
            {status.success && <p className="text-green-500 mb-4">{status.success}</p>}
            <button
              type="submit"
              disabled={status.submitting}
              className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-md ${
                status.submitting ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {status.submitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center mb-4 md:mb-0">
            <img src="/assets/logo.png" alt="Precise Draft Logo" className="h-8 w-8 mr-2" />
            <span className="text-xl font-bold">Precise Draft</span>
          </div>
          <p className="mb-4 md:mb-0">
            Transforming your marketing through the power of personalization.
          </p>
          <ul className="flex space-x-4">
            <li>
              <a href="https://facebook.com" aria-label="Facebook" className="hover:text-blue-400">
                <FaFacebookF />
              </a>
            </li>
            <li>
              <a href="https://instagram.com" aria-label="Instagram" className="hover:text-pink-400">
                <FaInstagram />
              </a>
            </li>
            <li>
              <a href="https://twitter.com" aria-label="Twitter" className="hover:text-blue-400">
                <FaTwitter />
              </a>
            </li>
            <li>
              <a href="https://youtube.com" aria-label="YouTube" className="hover:text-red-600">
                <FaYoutube />
              </a>
            </li>
            <li>
              <a href="https://linkedin.com" aria-label="LinkedIn" className="hover:text-blue-500">
                <FaLinkedinIn />
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default ContactForm;
